export const StyleStoreMutation = {
    SET_SHOW_STYLE: "SET_SHOW_STYLE"
};

function createEmptyState() {

    return {
        showStyle: null
    };
}

export const styleStore = {

    state() {

        return createEmptyState();
    },

    mutations: {

        clear(state) {
            Object.assign(state, createEmptyState());
        },

        [StyleStoreMutation.SET_SHOW_STYLE](state, style) {

            state.showStyle = style;
        }
    }
};